// packages/shared-hooks/src/clients/usePatchClientContact.ts
//
// `PATCH /clients/:id/contacts/:contactId` — edits an existing contact's
// `fullName` / `phone` / `comment`. Backend rejects duplicate phones with
// 409 DOMAIN_CONFLICT.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ClientContactSchema,
  type ClientContact,
  type PatchClientContactInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function usePatchClientContact(clientId: string, contactId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientContact, unknown, PatchClientContactInput>({
    mutationFn: (input) =>
      client.patch<ClientContact>(
        `/clients/${clientId}/contacts/${contactId}`,
        input,
        {},
        ClientContactSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
